import React, { useState } from 'react';
import * as Icon from 'react-feather';

const FormTable = ({ filteredData, classes, removeFromGroup }) => {
    return (
        <div className="c-table-responsive@wide">
            <table className="c-table u-ml-zero">
                <thead className="c-table__head">
                    <tr className="c-table__row">
                        <th className="c-table__cell c-table__cell--head">
                            Name
                        </th>
                        <th className="c-table__cell c-table__cell--head">
                            Entity
                        </th>
                        <th className="c-table__cell c-table__cell--head">
                            Qlik App Id
                        </th>
                        <th className="c-table__cell c-table__cell--head">
                            Actions
                        </th>
                    </tr>
                </thead>

                <tbody>
                    {filteredData.map((form) => (
                        <tr className="c-table__row" key={form._id}>
                            <td className="c-table__cell u-pb-xsmall u-pt-xsmall">
                                {form.name}
                            </td>
                            <td className="c-table__cell u-pb-xsmall u-pt-xsmall">
                                <small>{form.entity}</small>
                            </td>
                            <td className="c-table__cell u-pb-xsmall u-pt-xsmall">
                                <small>{form.qlikAppId}</small>
                            </td>
                            <td
                                className="c-table__cell u-pb-xsmall u-pt-xsmall"
                                width="70"
                            >
                                <button
                                    type={'button'}
                                    className={`c-btn ${classes.buttonDanger} u-m-xsmall c-btn--small u-m-xsmall has-arrow u-text-center`}
                                    onClick={() => removeFromGroup(form._id)}
                                >
                                    <Icon.Slash size={10} /> Delete From Group
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default FormTable;
